import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faUser,
    faRightFromBracket,
    faBars,
    faXmark,
    faCalendarDays
} from '@fortawesome/free-solid-svg-icons';

import './DashboardNav.css';
import CCHEventsList from './CCHEventsList';



function CCHDashboard() {
    const [cch, setCCH] = useState(null);
    const [message, setMessage] = useState('');
    const [activeTab, setActiveTab] = useState('events');
    const [menuOpen, setMenuOpen] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem('cchToken');
        const basePath = '/app';

        if (!token) {
            window.location.href = `${basePath}/cch/login`;
            return;
        }

        const user = JSON.parse(localStorage.getItem('cchData') || '{}');

        if (user.email) {
            setCCH(user);
        } else {
            window.location.href = `${basePath}/cch/login`;
        }
    }, []);


    const handleLogout = () => {
        localStorage.removeItem('cchToken');
        localStorage.removeItem('cchData');
        navigate('/app/cch/login');
    };

    if (message) return <p>{message}</p>;
    if (!cch) return <p>Se încarcă...</p>;

    return (
        <div className="dashboard-gradient-bg">
            <div className="dashboard-header">
                <h1 className="dashboard-title">Panel CCH</h1>

                <button
                    className="dashboard-menu-btn"
                    onClick={() => setMenuOpen(!menuOpen)}
                >
                    <FontAwesomeIcon icon={menuOpen ? faXmark : faBars} size="2x" />
                </button>

                <div className="dashboard-user-info desktop-only">
                    <nav className="dashboard-nav">
                        <button
                            className={`dashboard-nav-btn${activeTab === 'events' ? ' active' : ''}`}
                            onClick={() => setActiveTab('events')}
                        >
                            <FontAwesomeIcon icon={faCalendarDays} /> Campionate Naționale
                        </button>
                    </nav>

                    <div className="dashboard-actions">
                        <button className="dashboard-profile-btn" title="Profil">
                            <FontAwesomeIcon icon={faUser} size="2x" color="#222" />
                        </button>

                        <button
                            className="dashboard-logout-btn"
                            onClick={handleLogout}
                            title="Logout"
                        >
                            <FontAwesomeIcon icon={faRightFromBracket} size="lg" color="#222" />
                            Log-out
                        </button>
                    </div>
                </div>
            </div>

            <div className={`mobile-menu ${menuOpen ? 'open' : ''}`}>
                <nav className="mobile-nav">
                    <button
                        onClick={() => {
                            setActiveTab('events');
                            setMenuOpen(false);
                        }}
                    >
                        <FontAwesomeIcon icon={faCalendarDays} /> Campionate Naționale
                    </button>
                </nav>

                <hr className="mobile-divider" />

                <div className="mobile-actions">
                    <button onClick={() => setMenuOpen(false)}>
                        <FontAwesomeIcon icon={faUser} /> Profil
                    </button>

                    <button onClick={handleLogout}>
                        <FontAwesomeIcon icon={faRightFromBracket} /> Logout
                    </button>
                </div>
            </div>

            <div className="dashboard-stats-elements no-bg">
                <h2 className="dashboard-stat-title">
                    Bun venit <strong>{cch.email}</strong>
                </h2>

                {activeTab === 'events' && <CCHEventsList />}
            </div>
        </div>
    );
}

export default CCHDashboard;
